import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  let navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
        justifyContent: "center",
      }}
    >
      <Typography variant="h3" textAlign="center">
        Page Not Found
      </Typography>
      <Typography
        variant="subtitle1"
        textAlign="center"
        onClick={() => navigate(`/`)}
      >
        Go to Home Page
      </Typography>
      <Button
        variant="contained"
        color="primary"
        endIcon={<FaHome />}
        onClick={() => navigate(`/`)}
        sx={{ minWidth: "200px" }}
      >
        Home
      </Button>
    </Box>
  );
};

export default NotFound;
